import { render, staticRenderFns } from "./ProductDetailsApp.vue?vue&type=template&id=6c07c43a&scoped=true"
import script from "./ProductDetailsApp.vue?vue&type=script&lang=ts"
export * from "./ProductDetailsApp.vue?vue&type=script&lang=ts"
import style0 from "./ProductDetailsApp.vue?vue&type=style&index=0&id=6c07c43a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c07c43a",
  null
  
)

export default component.exports